<template>
    <form-wrapper class="form__fields" :isSubmittable="false">
        <div class="auth-token-form">
            <text-field
                :label="$t('pages.auth.verify_token.form.npi_number.label')"
                :placeholder="$t('pages.auth.verify_token.form.npi_number.placeholder')"
                :isRequired="true"
                :hasAutofocus="true"
                :formData="data"
                :error="npiErrorMessage"
                valuePath="npiNumber"
                @change="change($event)"
            ></text-field>

            <text-field
                :label="$t('pages.auth.verify_token.form.token.label')"
                :placeholder="$t('pages.auth.verify_token.form.token.placeholder')"
                :isRequired="true"
                :formData="data"
                :error="tokenErrorMessage"
                valuePath="token"
                @change="change($event)"
            ></text-field>

            <common-buttons class="verify-buttons">
                <common-button
                    :label="$t('pages.auth.verify_token.form.verify')"
                    :isProcessing="isLoading"
                    type="primary"
                    size="small"
                    @click="verifyToken"
                ></common-button>
            </common-buttons>
        </div>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'

    export default {
        mixins: [FormMixin],

        data() {
            return {
                isLoading: false,
                npiErrorMessage: '',
                tokenErrorMessage: '',
                data: {
                    npiNumber: '',
                    token: '',
                },
            }
        },

        methods: {
            verifyToken() {
                this.npiErrorMessage = ''
                this.tokenErrorMessage = ''

                if (this.data.npiNumber.length !== 10) {
                    this.npiErrorMessage = this.$t('pages.auth.verify_token.errors.npi_must_be_10_digits')
                    return
                }

                if (!this.data.token) {
                    this.tokenErrorMessage = this.$t('pages.auth.verify_token.errors.token_required')
                    return
                }

                const token = this.data.token.trim().toLowerCase()

                this.$router.push({
                    path: '/signup/register',
                    query: {
                        jit: token,
                    },
                })
            },
        },
    }
</script>

<style scoped lang="scss">
    .auth-token-form {
        display: flex;
        flex-direction: column;
        gap: 18px;
    }

    .verify-buttons {
        margin-top: 5px;
    }
</style>
